{
  "instances": {
    "metrics": {
      "label": "Métricas",
      "add_metric": "Agregar Métrica",

      "fetching_tags": "Recuperando tags disponibles",
      "no_tags": "(no tags)",
      "no_tags_available": "No hay tags disponibles.",
      "metrics_not_supported_spring_boot_1": "Métricas no está soportada para aplicaciones Spring Boot 1.x ."
    }
  }
}
